import { createAction } from 'typesafe-actions';

export const setPlatform = createAction('platform/SET_PLATFORM', resolve =>
  (platform: string) => resolve(platform)
);

export const setUhi = createAction('platform/SET_UHI', resolve =>
  (uhi: string) => resolve(uhi)
);